import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Menu, ShoppingBag, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const LINKS = [
    { label: "Home", href: "/" },
    { label: "Services", href: "/services" },
    { label: "Experiences", href: "/experiences" },
    { label: "Products", href: "/products" },
    { label: "Journal", href: "/blog" },
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
];

export default function XplosivNavbar() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { count, openDrawer } = useCart();
    return (
        <header className="xp-header" data-testid="site-navbar">
            <div className="xp-header__ribbon"><span>EVENTS WITH A POINT OF VIEW</span><span>DELHI · INDIA <i>✳</i> MADE TO BE REMEMBERED</span></div>
            <div className="xp-header__main">
                <div className="xp-header__left">
                    <button className="xp-menu-toggle" type="button" onClick={() => setMobileOpen((open) => !open)} aria-label={mobileOpen ? "Close navigation" : "Open navigation"} aria-expanded={mobileOpen}>{mobileOpen ? <X size={21} /> : <Menu size={21} />}</button>
                    <nav className="xp-nav xp-nav--left" aria-label="Primary navigation">{LINKS.slice(0, 3).map((item) => <Link key={item.label} to={item.href}>{item.label}</Link>)}</nav>
                </div>
                <Link to="/" className="xp-brand" aria-label="X-Plosiv home" data-testid="navbar-logo"><img src="/xplosiv-logo-removebg-preview.png" alt="X-Plosiv Events and Promotions" /></Link>
                <div className="xp-header__right">
                    <nav className="xp-nav xp-nav--right" aria-label="More navigation">{LINKS.slice(3).map((item) => <Link key={item.label} to={item.href}>{item.label}</Link>)}</nav>
                    <button className="xp-cart-button" type="button" onClick={openDrawer} aria-label={`Open bag${count ? `, ${count} items` : ""}`}><ShoppingBag size={17} />{count > 0 && <span>{count}</span>}</button>
                    <Link className="xp-book-button" to="/contact">Book an event <ArrowUpRight size={15} /></Link>
                </div>
            </div>
            {mobileOpen && <nav className="xp-mobile-nav" aria-label="Mobile navigation">{LINKS.map((item) => <Link key={item.label} to={item.href} onClick={() => setMobileOpen(false)}>{item.label}<ArrowUpRight size={15} /></Link>)}<Link className="xp-mobile-nav__cta" to="/contact" onClick={() => setMobileOpen(false)}>Start planning <ArrowUpRight size={16} /></Link></nav>}
        </header>
    );
}